import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import { AuthContext } from '../context/authContext/AuthContext';

const Profile = () => {
  const PF = 'https://ecommerce-api-l3as.onrender.com/images/';
  const { user } = useContext(AuthContext);
  const [clicked, setClicked] = useState(false);
  const [name, setName] = useState(user?.data.user.username);
  const [email, setEmail] = useState(user?.data.user.email);
  const [prevPassword, setPrevPassword] = useState('••••••••');
  const [newPassword, setNewPassword] = useState('••••••••');
  const [confirmPassword, setConfirmPassword] = useState('••••••••');

  window.addEventListener('click', (e) => {
    if (e.target.id === 'img' || e.target.id === 'edit') {
    } else {
      setClicked(false);
    }
  });

  if (!user)
    return (
      <>
        <Breadcrumbs>
          <Link to="/">Home</Link>
          {/* window.location.href */}
          Profile
        </Breadcrumbs>
        <div className="py-10">
          <div className="tw-container h-80 flex justify-center items-center flex-col gap-8">
            <h1>Log In First To See Your Profile</h1>
            <Link to="/login" className="btn text-2xl bg-blue-500 text-blue-50">
              LOGIN HERE
            </Link>
          </div>
        </div>
      </>
    );

  return (
    <>
      <Breadcrumbs>
        <Link to="/">Home</Link>
        Profile
      </Breadcrumbs>
      <div className="pt-10">
        <div>
          <h2 className="text-center font-bold text-3xl lg:text-4xl">Your Profile</h2>
          <div className="mt-3 w-24 h-1 bg-blue-400 mx-auto" />
        </div>
        <div className="tw-container bg-gray-200">
          <div className="flex justify-center my-10 gap-20">
            <div>
              <form className="flex flex-col gap-3 my-10">
                <div>
                  <label htmlFor="name" className="block py-2">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    value={name}
                    className="py-2 px-3 w-80 outline-none border border-gray-600 rounded bg-gray-100"
                    required
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block py-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    className="py-2 px-3 w-80 outline-none border border-gray-600 rounded bg-gray-100"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <button className="btn w-48 bg-blue-500 my-2 text-white hover:bg-blue-600">
                  Update Profile
                </button>
              </form>

              <form className="flex flex-col gap-5 my-10">
                <div>
                  <label htmlFor="prevPassword" className="block py-2">
                    Previous Password
                  </label>
                  <input
                    type="password"
                    id="prevPassword"
                    placeholder={prevPassword}
                    className="py-2 px-3 w-80 outline-none border border-gray-600 rounded bg-gray-100 pl-2"
                    required
                    onChange={(e) => setPrevPassword(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="password" className="block py-2">
                    New Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    placeholder={newPassword}
                    className="py-2 px-3 w-80 outline-none border border-gray-600 rounded bg-gray-100"
                    required
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="confirmPassword" className="block py-2">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    id="confirmPassword"
                    placeholder={confirmPassword}
                    className="py-2 px-3 w-80 outline-none border border-gray-600 rounded bg-gray-100"
                    required
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <button className="btn w-72 bg-blue-500 my-2 text-white hover:bg-blue-600">
                  Update Password
                </button>
              </form>
            </div>

            <div className="my-10">
              {user?.data.user.profilePic ? (
                <>
                  <div className="relative ">
                    <img
                      className="w-48 rounded-full shadow-md cursor-pointer"
                      id="img"
                      src={PF + user.data.user.profilePic}
                      alt=""
                      onClick={() => setClicked((prev) => !prev)}
                    />
                    <div className="absolute bottom-2 left-0 bg-black rounded text-white  flex items-center gap-2 text-sm">
                      <button
                        className="py-1 px-2 flex items-center gap-2 text-sm"
                        id="edit"
                        onClick={() => setClicked((prev) => !prev)}
                      >
                        <i className="fas fa-pencil-alt"></i>
                        <p>Edit</p>
                      </button>
                      <div
                        className={
                          clicked
                            ? 'absolute -bottom-20 -left-3 bg-black rounded w-40'
                            : 'opacity-0 hidden'
                        }
                      >
                        <div className="w-16 overflow-hidden inline-block absolute -top-5 left-5">
                          <div className=" h-5 w-5 bg-black rotate-45 transform origin-bottom-left"></div>
                        </div>

                        <label
                          htmlFor="uploadPic"
                          className="py-2 px-3 text-white w-full block text-xs hover:bg-gray-800 text-center rounded-t cursor-pointer"
                        >
                          Upload a Photo
                        </label>
                        <input
                          accept="image/*"
                          type="file"
                          id="uploadPic"
                          style={{ display: 'none' }}
                        />
                        <button className="py-2 px-3 text-white w-full text-xs hover:bg-gray-800 rounded-b">
                          Remove Photo
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <i className="text-7xl fa fa-user"></i>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile;
